import { parseDateWithHoursUTC } from "@/lib/utils";
import i18n from "@/i18n";
import { CheckIcon } from "@radix-ui/react-icons";
import { ColumnDef } from "@tanstack/react-table";
import { Link } from "@heroui/link";
import { parseToDateValue } from "@/features/FormCard/utils";

// Define the F1IssuersExclusion type
export type F1IssuersExclusion = {
  id: number;
  issuer_id?: number;
  issuer_name?: string;
  date?: Date;
  exception?: number;
  created_at: string;
  updated_at: string;
};

// Define the columns for the table
export const f1_issuers_exclusion_columns: ColumnDef<F1IssuersExclusion>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "issuer_id",
    header: "Issuer ID",
  },
  {
    accessorKey: "issuer_name",
    header: "Issuer Name",
  },
  {
    accessorKey: "exception",
    header: "Exception",
    cell: ({ row }) => {
      const isManual = row.getValue("exception");
      return (
        isManual && (
          <div className="pl-5">
            <CheckIcon />
          </div>
        )
      );
    },
  },
  {
    accessorKey: "date",
    header: "Date",
    cell: ({ row }) => {
      return (
        <div className="whitespace-nowrap">
          {String(parseToDateValue(row.getValue("date")))}
        </div>
      );
    },
  },
  {
    accessorKey: "created_at",
    header: "created At",
    cell: ({ row }) => {
      return (
        <div className="whitespace-nowrap">
          {parseDateWithHoursUTC(String(row.getValue("created_at")))}
        </div>
      );
    },
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => {
      return (
        <div className="whitespace-nowrap">
          {parseDateWithHoursUTC(String(row.getValue("updated_at")))}
        </div>
      );
    },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
